define('views/contact/contact',[
	'backbone',
	'views/_base/baseview',
	'text!views/contact/contact.html',
	'text!views/contact/contact_bcbssc.html',
	'text!views/contact/contact_csnp.html',
	'text!views/contact/contact_rxsavings.html',
	'text!views/contact/contact_proteus.html',
	'text!views/contact/contact_bcbsal.html',
	'text!views/contact/contact_almyblue.html'
], function(Backbone, BaseView, Template, BcbsscTemplate, CSNPTemplate, RxsavingsTemplate, ProteusTemplate, BcbsalTemplate, AlMyBlueTemplate){
	'use strict';

	return BaseView.extend({
		className : 'profile-content',
		tagName   : 'div',
		needsAuth : false,
		isRender  : false,
		events    : {},
		
		initialize: function(options){
			options = options || {};

			this.site_version = pf.getContent('version.id');
			
			this.elementName = options.elementName;

			BaseView.prototype.initialize(this);
		},

		render: function(){
			var that = this;

			this.$el.html(this.template());

			return this;
		},

		loadData: function(){

			if(this.site_version == enums.siteVersion.bcbsal){
				this.template = _.template(BcbsalTemplate);
			} else if(this.site_version == enums.siteVersion.almyblue){
					this.template = _.template(AlMyBlueTemplate);
			} else if(this.site_version == enums.siteVersion.rxsavings){
				this.template = _.template(RxsavingsTemplate);
			} else if(this.site_version == enums.siteVersion.bcbssc){
				this.template = _.template(BcbsscTemplate);
			} else if(this.site_version == enums.siteVersion.csnp){
				this.template = _.template(CSNPTemplate);
			} else if (this.site_version == enums.siteVersion.proteus){
				this.template = _.template(ProteusTemplate);
			} else {
				this.template = _.template(Template);
			}

			this.render();

		},

		close: function(){}
	});
});

